export const REJECTION_REASONS = [
  {
    label:
      "El documento que subiste no es claro. Por favor, toma una nueva foto o escanea el documento completo, asegurándote de que no se vea borroso, cortado o con reflejos de luz para que podamos leer toda la información.",
    value: "document_not_clear",
  },
  {
    label:
      "La información de este requisito no coincide con los datos que llenaste en el formulario. Por favor, revisa que todos los datos sean correctos y coincidan.",
    value: "information_mismatch",
  },
  {
    label:
      "El comprobante de domicilio no es válido. Por favor, asegúrate de que sea un recibo reciente (no mayor a 3 meses) de servicios como luz, agua, gas, internet o telefonía fija.",
    value: "invalid_address_proof",
  },
  {
    label:
      "La identificación proporcionada ha expirado. Por favor, sube un documento que esté vigente. Puede ser INE, Pasaporte o Licencia de conducir de Jalisco.",
    value: "expired_identification",
  },
  {
    label:
      "Se requieren comprobantes de ingresos de los últimos 3 meses. Por favor, adjunta todos los comprobantes de ingresos de los 3 meses más recientes.",
    value: "missing_income_proof",
  },
  {
    label: "Otro",
    value: "other",
  },
];
